import { Mapper } from "../../../../../core/base";
import { ProductsAdditionalInfoWebEntity, PublicLocationWebEntity } from "./public-location.web-entity";
import { ProductsAdditionalInfo, PublicLocation } from "../../../../../core/domain/models";

export class PublicLocationMapper extends Mapper<
  PublicLocationWebEntity,
  PublicLocation
> {
  mapFrom(param: PublicLocationWebEntity): PublicLocation {
    return {
      id: param.id,
      locationId : param.locationId,
      name: param.name,
      longitude: param.longitude,
      latitude: param.latitude,
      address: param.address,
      postalCode: param.postalCode,
      city: param.city,
      country: param.country,
      stopTime: param.stopTime,
      isInfrastructure: param.isInfrastructure,
      productsAdditionalInfo: param.productsAdditionalInfo.map(
        (product: ProductsAdditionalInfoWebEntity): ProductsAdditionalInfo => ({
          productId: product.productId,
          productName: product.productName,
          productAdditionalInfo: product.productAdditionalInfo,
          daoLocationKey: product.daoLocationKey,
          productKeyMapping: product.productKeyMapping
        })
      ),
      segment: param.segment,
      tenantLocationId: param.tenantLocationId

    };
  }

  mapTo(param: PublicLocation): PublicLocationWebEntity {
    return {
      id: param.id,
      locationId : param.locationId,
      name: param.name,
      longitude: param.longitude,
      latitude: param.latitude,
      address: param.address,
      postalCode: param.postalCode,
      city: param.city,
      country: param.country,
      stopTime: param.stopTime,
      isInfrastructure: param.isInfrastructure,
      productsAdditionalInfo: param.productsAdditionalInfo.map(
        (product: ProductsAdditionalInfo): ProductsAdditionalInfoWebEntity => ({
          productId: product.productId,
          productName: product.productName,
          productAdditionalInfo: product.productAdditionalInfo,
          daoLocationKey: product.daoLocationKey,
          productKeyMapping: product.productKeyMapping
        })
      ),
      segment: param.segment,
      tenantLocationId: param.tenantLocationId
    };
  }
}
